import styled from 'styled-components'
import { Icon } from 'components/atoms'
import React from 'react'

export const Container = styled.div`
  .select-day {
    display: flex;
    flex-direction: column;
    margin: 29px 0 8px 0;

    > div:first-child {
      margin-top: 16px;
    }
  }

  .select-time {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 16px;

    > div:first-child {
      flex-grow: 1;
      margin-left: 10px;
    }
  }

  &.padding-bottom {
    margin-bottom: 10px;
  }
`

export const PanelButton = styled.button`
  position: relative;
  background: ${ (props) =>
    props.deactivated ? 'rgba(255, 255, 255, 0.4)' : props.theme.colors.weiss };
  ${ (props) =>
    props.variant === 'select' &&
    `background: ${ props.theme.colors['icon-grau2'] }80;` }
  width: 100%;
  border: 1px solid ${ (props) => props.theme.colors['icon-grau3'] };
  ${ (props) =>
    props.variant === 'select' &&
    `
      border: none;
      border-bottom: 1px solid ${ props.theme.colors['hintergrund-allgemein'] };
    ` }
  padding: 13px 50px 13px 10px;
  line-height: 1;
  text-align: left;
  font-weight: 200;
  display: flex;
  justify-content: space-between;
  color: ${ (props) => props.theme.colors['standard-schwarz'] };

  & > * {
    opacity: ${ (props) => (props.deactivated ? '0.4' : '1') };
  }

  :after {
    font: normal normal normal 14px 'aok-icons-functional';
    position: absolute;
    top: 50%;
    right: 12px;
    margin-top: -0.5em;
    color: ${ (props) => props.theme.colors['icon-grau1'] };
    transition: 0.3s transform ease-out;
    transform-origin: center center;
    display: inline-block;
    line-height: 1;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transform: translate(0, 0);
    content: '';
    vertical-align: middle;
    opacity: ${ (props) => (props.deactivated ? '0.4' : '1') };
  }

  :hover:after {
    transform: rotate(90deg);
  }

  .title-row {
    display: flex;
    align-items: center;

    .tooltip {
      margin-left: 10px;
    }
  }
`

export const PanelBody = styled.div`
  border-color: ${ (props) => props.theme.colors['icon-grau3'] };
  border-width: 0 1px 1px;
  border-style: solid;
  border-bottom-width: ${ (props) => (props.open ? '1px' : '0') };
  ${ (props) => props.variant === 'select' && `border: none;` }
  background: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
  transition: height ease 200ms;
  ${ (props) => props.deactivated && 'text-align: center;' }
`

export const ChildrenWrapper = styled.div`
  padding: 20px 20px 30px;
`

// export const CheckIcon = styled(Icon)`
export const CheckIcon = styled((props) => <Icon { ...props } />)`
  color: ${ (props) => props.theme.colors.hellgruen1 };
`

export const FilterAccordionItem = styled.div`
  background: ${ (props) => props.theme.colors['icon-grau2'] }80;
  padding: 12px 50px 13px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;

  & > div {
    margin-left: 8px;
  }

  .tooltip {
    margin-left: 10px;
  }
`
